import React, { useState, useEffect } from 'react';
import lessonService from '../../services/teacher/lessonService';
import useAuth from '../../hooks/useAuth';

export default function LessonsPage() {
  const [lessons, setLessons] = useState([]);
  const [filteredLessons, setFilteredLessons] = useState([]);
  const [students, setStudents] = useState([]);
  const [courses, setCourses] = useState([]);
  const [kursSatisList, setKursSatisList] = useState([]); // Yeni state
  const [loading, setLoading] = useState(true);
  const [showAddModal, setShowAddModal] = useState(false);

  const [showFilters, setShowFilters] = useState(false);
  
  // Form data
  const [formData, setFormData] = useState({
    kurs_satis_id: '', // Yeni alan
    ogrenci_id: '',
    ders_id: '',
    ders_konusu: '',
    baslangic_tarihi: '',
    ders_sure: '40'
  });
  
  // Filtre state'leri
  const [filters, setFilters] = useState({
    search: '',
    ogrenci_id: '',
    ders_id: '',
    start_date: '',
    end_date: '',
    ders_sure: ''
  });
  
  // Hakediş hesaplamaları için state
  const [totalEarnings, setTotalEarnings] = useState(0);
  const [monthlyEarnings, setMonthlyEarnings] = useState(0);
  const [avansBalance, setAvansBalance] = useState(0);
  
  const { user } = useAuth();

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    applyFilters();
    calculateEarnings();
  }, [lessons, filters]);

  const fetchData = async () => {
    try {
      setLoading(true);
      
      const [lessonsData, studentsData, coursesData, kursSatisData, earningsData] = await Promise.all([
        lessonService.getAllLessons(),
        lessonService.getTeacherStudents(),
        lessonService.getAllCourses(),
        lessonService.getKursSatisList(), // Yeni çağrı
        lessonService.getEarningsSummary() // Hakediş özeti için
      ]);
      
      setLessons(lessonsData);
      setFilteredLessons(lessonsData);
      setStudents(studentsData);
      setCourses(coursesData);
      setKursSatisList(kursSatisData); // Yeni set
      
      // Avans bakiyesini set et
      if (earningsData && earningsData.summary && earningsData.summary.bu_ay_detay) {
        setAvansBalance(parseFloat(earningsData.summary.bu_ay_detay.avans || 0));
      }
    } catch (error) {
      console.error('Veri yükleme hatası:', error);
      alert('Veriler yüklenirken hata oluştu');
    } finally {
      setLoading(false);
    }
  };

  const applyFilters = () => {
    let filtered = [...lessons];
    
    // Arama filtresi (ders konusu)
    if (filters.search) {
      filtered = filtered.filter(lesson => 
        lesson.ders_konusu.toLowerCase().includes(filters.search.toLowerCase())
      );
    }
    
    // Öğrenci filtresi
    if (filters.ogrenci_id) {
      filtered = filtered.filter(lesson => 
        lesson.ogrenci_id === parseInt(filters.ogrenci_id)
      );
    }
    
    // Ders filtresi
    if (filters.ders_id) {
      filtered = filtered.filter(lesson => 
        lesson.ders_id === parseInt(filters.ders_id)
      );
    }
    
    // Ders süresi filtresi
    if (filters.ders_sure) {
      filtered = filtered.filter(lesson => 
        lesson.ders_sure === parseInt(filters.ders_sure)
      );
    }
    
    // Tarih aralığı filtresi
    if (filters.start_date) {
      filtered = filtered.filter(lesson => 
        new Date(lesson.baslangic_tarihi) >= new Date(filters.start_date)
      );
    }
    
    if (filters.end_date) {
      filtered = filtered.filter(lesson => 
        new Date(lesson.baslangic_tarihi) <= new Date(filters.end_date + 'T23:59:59')
      );
    }
    
    setFilteredLessons(filtered);
  };

  const calculateEarnings = () => {
    // Toplam hakediş
    const total = lessons.reduce((sum, lesson) => sum + (parseFloat(lesson.ders_ucret) || 0), 0);
    setTotalEarnings(total);
    
    // Bu ayki hakediş
    const currentMonth = new Date().getMonth();
    const currentYear = new Date().getFullYear();
    
    const monthlyTotal = lessons
      .filter(lesson => {
        const lessonDate = new Date(lesson.baslangic_tarihi);
        return lessonDate.getMonth() === currentMonth && lessonDate.getFullYear() === currentYear;
      })
      .reduce((sum, lesson) => sum + (parseFloat(lesson.ders_ucret) || 0), 0);
    
    setMonthlyEarnings(monthlyTotal);
  };

  const clearFilters = () => {
    setFilters({
      search: '',
      ogrenci_id: '',
      ders_id: '',
      start_date: '',
      end_date: '',
      ders_sure: ''
    });
  };

  const handleAddLesson = async (e) => {
    e.preventDefault();

    if (!formData.kurs_satis_id) {
      alert('Kurs satışı seçimi zorunludur.');
      return;
    }
    
    // Tarih kontrolü - sadece mevcut ay içindeki tarihlere izin ver
    const selectedDate = new Date(formData.baslangic_tarihi);
    const today = new Date();
    const currentMonth = today.getMonth();
    const currentYear = today.getFullYear();
    
    // Seçilen tarihin ay ve yılını al
    const selectedMonth = selectedDate.getMonth();
    const selectedYear = selectedDate.getFullYear();
    
    // Mevcut aydan farklı bir ay veya yıl seçilmişse engelle
    if (selectedMonth !== currentMonth || selectedYear !== currentYear) {
      alert(`Sadece ${today.toLocaleDateString('tr-TR', { month: 'long', year: 'numeric' })} ayı içindeki tarihlere ders ekleyebilirsiniz!`);
      return;
    }
    
    // Gelecek tarih kontrolü (mevcut ay içinde olsa bile gelecek tarihe izin verme)
    today.setHours(0, 0, 0, 0);
    selectedDate.setHours(0, 0, 0, 0);
    
    if (selectedDate > today) {
      alert('Gelecek tarihe ders ekleyemezsiniz! Sadece bugün veya bu ay içindeki geçmiş tarihlere ders ekleyebilirsiniz.');
      return;
    }
    
    try {
      // Ücret tutarlılığı için sadece kurs satışı bazlı akış kullanılmalı
      const result = await lessonService.createLessonWithKursSatis(formData);
        
      if (result.message) {
        alert(result.message);
        setShowAddModal(false);
        resetForm();
        fetchData();
      }
    } catch (error) {
      if (error.response?.status === 401) {
        alert('Yetkilendirme hatası! Token geçersiz veya süresi dolmuş olabilir. Lütfen çıkış yapıp tekrar giriş yapın.');
      } else if (error.response?.status === 400) {
        alert(`Validation Hatası: ${error.response?.data?.message || 'Gönderilen veriler hatalı'}`);
      } else if (error.response?.status === 500) {
        alert(`Server Hatası: ${error.response?.data?.message || 'Backend\'de bir hata oluştu'}`);
      } else {
        alert(error.response?.data?.message || error.message || 'Ders eklenirken hata oluştu');
      }
    }
  };



  const resetForm = () => {
    setFormData({
      kurs_satis_id: '', // Yeni alan
      ogrenci_id: '',
      ders_id: '',
      ders_konusu: '',
      baslangic_tarihi: '',
      ders_sure: '40'
    });
  };

  // Kurs satış seçildiğinde otomatik doldur
  const handleKursSatisChange = (e) => {
    const selectedId = e.target.value;
    const selectedKursSatis = kursSatisList.find(ks => ks.id == selectedId);
    
    if (selectedKursSatis) {
      // Dersleri parse et
      let derslerArray = [];
      try {
        derslerArray = JSON.parse(selectedKursSatis.dersler_ids || '[]');
      } catch (err) {
        derslerArray = [];
      }
      
      setFormData({
        ...formData,
        kurs_satis_id: selectedId,
        ogrenci_id: selectedKursSatis.ogrenci_id,
        ders_id: derslerArray.length > 0 ? derslerArray[0] : '' // İlk dersi seç
      });
    } else {
      setFormData({
        ...formData,
        kurs_satis_id: '',
        ogrenci_id: '',
        ders_id: ''
      });
    }
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('tr-TR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-96">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-blue-50 p-4 md:p-6 lg:p-8">
      {/* Başlık ve Yeni Ders Butonu */}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-8">
        <div>
          <h1 className="text-2xl md:text-3xl lg:text-4xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
            Derslerim
          </h1>
          <p className="text-sm text-gray-600 mt-1">
            Tüm derslerinizi buradan yönetebilirsiniz
          </p>
        </div>
        <button
          onClick={() => setShowAddModal(true)}
          className="inline-flex items-center px-5 py-3 bg-gradient-to-r from-blue-600 to-blue-700 text-white font-medium rounded-xl hover:from-blue-700 hover:to-blue-800 transition-all duration-200 shadow-md hover:shadow-xl transform hover:scale-105"
        >
          <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
          </svg>
          Yeni Ders Ekle
        </button>
      </div>

      {/* Hakediş Özet Kartları - Modern Design */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6 mb-6">
        {/* Toplam Ders Sayısı */}
        <div className="bg-gradient-to-br from-blue-50 to-blue-100 border border-blue-200 rounded-xl shadow-md hover:shadow-lg transition-all duration-300 p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-xs uppercase tracking-wide text-blue-600 font-semibold mb-1">Toplam Ders</p>
              <p className="text-3xl font-extrabold text-blue-900">{lessons.length}</p>
              <p className="text-xs text-blue-700 mt-1">Verilen ders sayısı</p>
            </div>
            <div className="bg-blue-500 bg-opacity-20 rounded-full p-3">
              <svg className="w-10 h-10 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
              </svg>
            </div>
          </div>
        </div>
        
        {/* Bu Ayki Hakediş */}
        <div className="bg-gradient-to-br from-green-50 to-green-100 border border-green-200 rounded-xl shadow-md hover:shadow-lg transition-all duration-300 p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-xs uppercase tracking-wide text-green-600 font-semibold mb-1">Bu Ay</p>
              <p className="text-3xl font-extrabold text-green-900">
                <span className="text-lg">₺</span>{monthlyEarnings.toFixed(0)}
              </p>
              <p className="text-xs text-green-700 mt-1">
                {new Date().toLocaleDateString('tr-TR', { month: 'long' })} ayı
              </p>
            </div>
            <div className="bg-green-500 bg-opacity-20 rounded-full p-3">
              <svg className="w-10 h-10 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
            </div>
          </div>
        </div>
        
        {/* Toplam Hakediş */}
        <div className="bg-gradient-to-br from-purple-50 to-purple-100 border border-purple-200 rounded-xl shadow-md hover:shadow-lg transition-all duration-300 p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-xs uppercase tracking-wide text-purple-600 font-semibold mb-1">Toplam</p>
              <p className="text-3xl font-extrabold text-purple-900">
                <span className="text-lg">₺</span>{totalEarnings.toFixed(0)}
              </p>
              <p className="text-xs text-purple-700 mt-1">Genel toplam</p>
            </div>
            <div className="bg-purple-500 bg-opacity-20 rounded-full p-3">
              <svg className="w-10 h-10 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
          </div>
        </div>
        
        {/* Avans Bakiyesi Kartı */}
        <div className="bg-gradient-to-br from-orange-50 to-orange-100 border border-orange-200 rounded-xl shadow-md hover:shadow-lg transition-all duration-300 p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-xs uppercase tracking-wide text-orange-600 font-semibold mb-1">Avans</p>
              <p className="text-3xl font-extrabold text-orange-900">
                <span className="text-lg">₺</span>{avansBalance.toFixed(0)}
              </p>
              <p className="text-xs text-orange-700 mt-1">
                {avansBalance > 0 ? 'Avans borcu' : 'Avans yok'}
              </p>
            </div>
            <div className="bg-orange-500 bg-opacity-20 rounded-full p-3">
              <svg className="w-10 h-10 text-orange-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
              </svg>
            </div>
          </div>
        </div>
      </div>

      {/* Filtre Bölümü - Modern Design */}
      <div className="bg-white rounded-xl shadow-md border border-gray-100 mb-6 overflow-hidden">
        <div className="bg-gradient-to-r from-gray-50 to-gray-100 px-6 py-4 border-b border-gray-200">
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
            <div className="flex items-center gap-3">
              <div className="p-2 bg-white rounded-lg shadow-sm">
                <svg className="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z" />
                </svg>
              </div>
              <div>
                <h3 className="text-lg font-semibold text-gray-800">Filtreler</h3>
                <span className="text-xs text-gray-600">
                  {filteredLessons.length} / {lessons.length} ders gösteriliyor
                </span>
              </div>
            </div>
            <button
              onClick={() => setShowFilters(!showFilters)}
              className="inline-flex items-center px-4 py-2 text-sm font-medium text-blue-700 bg-blue-50 rounded-lg hover:bg-blue-100 transition-colors duration-200"
            >
              {showFilters ? 'Gizle' : 'Göster'}
              <svg
                className={`ml-2 h-4 w-4 transform transition-transform duration-200 ${showFilters ? 'rotate-180' : ''}`}
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
              </svg>
            </button>
          </div>
        </div>
        
        {showFilters && (
          <div className="p-6 bg-gray-50 animate-in slide-in-from-top duration-200">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
              {/* Arama */}
              <div className="group">
                <label className="block text-xs font-semibold text-gray-700 uppercase tracking-wider mb-2">
                  <svg className="inline w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                  </svg>
                  Ders Konusu
                </label>
                <input
                  type="text"
                  value={filters.search}
                  onChange={(e) => setFilters({...filters, search: e.target.value})}
                  placeholder="Konu ara..."
                  className="w-full px-4 py-2.5 bg-white border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
                />
              </div>
              
              {/* Öğrenci Filtresi */}
              <div className="group">
                <label className="block text-xs font-semibold text-gray-700 uppercase tracking-wider mb-2">
                  <svg className="inline w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                  </svg>
                  Öğrenci
                </label>
                <select
                  value={filters.ogrenci_id}
                  onChange={(e) => setFilters({...filters, ogrenci_id: e.target.value})}
                  className="w-full px-4 py-2.5 bg-white border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 cursor-pointer"
                >
                  <option value="">Tüm Öğrenciler</option>
                  {students.map((student) => (
                    <option key={student.id} value={student.id}>
                      {student.name}
                    </option>
                  ))}
                </select>
              </div>
              
              {/* Ders Filtresi */}
              <div className="group">
                <label className="block text-xs font-semibold text-gray-700 uppercase tracking-wider mb-2">
                  <svg className="inline w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
                  </svg>
                  Ders
                </label>
                <select
                  value={filters.ders_id}
                  onChange={(e) => setFilters({...filters, ders_id: e.target.value})}
                  className="w-full px-4 py-2.5 bg-white border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 cursor-pointer"
                >
                  <option value="">Tüm Dersler</option>
                  {courses.map((course) => (
                    <option key={course.id} value={course.id}>
                      {course.ders_adi}
                    </option>
                  ))}
                </select>
              </div>
              
              {/* Başlangıç Tarihi */}
              <div className="group">
                <label className="block text-xs font-semibold text-gray-700 uppercase tracking-wider mb-2">
                  <svg className="inline w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                  </svg>
                  Başlangıç Tarihi
                </label>
                <input
                  type="date"
                  value={filters.start_date}
                  onChange={(e) => setFilters({...filters, start_date: e.target.value})}
                  className="w-full px-4 py-2.5 bg-white border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 cursor-pointer"
                />
              </div>
              
              {/* Bitiş Tarihi */}
              <div className="group">
                <label className="block text-xs font-semibold text-gray-700 uppercase tracking-wider mb-2">
                  <svg className="inline w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                  </svg>
                  Bitiş Tarihi
                </label>
                <input
                  type="date"
                  value={filters.end_date}
                  onChange={(e) => setFilters({...filters, end_date: e.target.value})}
                  className="w-full px-4 py-2.5 bg-white border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 cursor-pointer"
                />
              </div>
              
              {/* Ders Süresi Filtresi */}
              <div className="group">
                <label className="block text-xs font-semibold text-gray-700 uppercase tracking-wider mb-2">
                  <svg className="inline w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  Ders Süresi
                </label>
                <select
                  value={filters.ders_sure}
                  onChange={(e) => setFilters({...filters, ders_sure: e.target.value})}
                  className="w-full px-4 py-2.5 bg-white border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 cursor-pointer"
                >
                  <option value="">Tüm Süreler</option>
                  <option value="40">40 Dakika</option>
                  <option value="60">60 Dakika</option>
                  <option value="80">80 Dakika</option>
                  <option value="120">120 Dakika</option>
                </select>
              </div>
            </div>
            
            {/* Filtreleri Temizle Butonu */}
            <div className="mt-6 flex flex-col sm:flex-row gap-3 justify-end">
              <button
                onClick={clearFilters}
                className="px-5 py-2.5 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 hover:border-gray-400 transition-all duration-200 inline-flex items-center justify-center"
              >
                <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                </svg>
                Filtreleri Temizle
              </button>
            </div>
          </div>
        )}
      </div>

      {/* Dersler Listesi - Responsive Design */}
      {filteredLessons.length === 0 ? (
        <div className="bg-white rounded-lg shadow-lg p-12 text-center">
          <div className="text-gray-400 mb-4">
            <svg className="mx-auto h-16 w-16" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} 
                d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
            </svg>
          </div>
          <h3 className="text-xl font-semibold text-gray-900 mb-2">
            {lessons.length === 0 ? 'Henüz ders eklenmemiş' : 'Filtrelere uygun ders bulunamadı'}
          </h3>
          <p className="text-gray-600">
            {lessons.length === 0 
              ? 'İlk dersinizi eklemek için yukarıdaki "Yeni Ders Ekle" butonunu kullanın.' 
              : 'Farklı filtreler deneyebilir veya filtreleri temizleyebilirsiniz.'}
          </p>
        </div>
      ) : (
        <>
          {/* Mobil Görünüm - Kart Sistemi */}
          <div className="block lg:hidden space-y-4">
            {filteredLessons.map((lesson) => (
              <div key={lesson.id} className="bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-200">
                <div className="p-5">
                  <div className="flex justify-between items-start mb-3">
                    <div>
                      <h3 className="text-lg font-semibold text-gray-900">
                        {lesson.ogrenci_adi || 'Öğrenci'}
                      </h3>
                      <p className="text-sm text-gray-600">
                        {lesson.ders_adi || 'Ders'}
                      </p>
                    </div>
                    <div className="text-right">
                      <span className="inline-flex px-3 py-1 text-xs font-bold rounded-full bg-gradient-to-r from-green-400 to-green-600 text-white">
                        ₺{parseFloat(lesson.ders_ucret || 0).toFixed(2)}
                      </span>
                    </div>
                  </div>
                  
                  <div className="space-y-2 mb-3">
                    <div className="flex items-center text-sm">
                      <svg className="w-4 h-4 text-gray-400 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                      </svg>
                      <span className="text-gray-700 font-medium">Konu:</span>
                      <span className="text-gray-600 ml-1">{lesson.ders_konusu}</span>
                    </div>
                    
                    <div className="flex items-center text-sm">
                      <svg className="w-4 h-4 text-gray-400 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                      </svg>
                      <span className="text-gray-700 font-medium">Tarih:</span>
                      <span className="text-gray-600 ml-1">{formatDate(lesson.baslangic_tarihi)}</span>
                    </div>
                    
                    <div className="flex items-center text-sm">
                      <svg className="w-4 h-4 text-gray-400 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                      <span className="text-gray-700 font-medium">Süre:</span>
                      <span className="inline-flex ml-1 px-2 py-0.5 text-xs font-semibold rounded-full bg-blue-100 text-blue-800">
                        {lesson.ders_sure} dakika
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Masaüstü Görünüm - Modern Tablo */}
          <div className="hidden lg:block bg-white rounded-xl shadow-lg overflow-hidden">
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead>
                  <tr className="bg-gradient-to-r from-blue-600 to-blue-700 text-white">
                    <th className="px-6 py-4 text-left text-xs font-semibold uppercase tracking-wider">
                      Öğrenci
                    </th>
                    <th className="px-6 py-4 text-left text-xs font-semibold uppercase tracking-wider">
                      Ders
                    </th>
                    <th className="px-6 py-4 text-left text-xs font-semibold uppercase tracking-wider">
                      Konu
                    </th>
                    <th className="px-6 py-4 text-center text-xs font-semibold uppercase tracking-wider">
                      Tarih & Saat
                    </th>
                    <th className="px-6 py-4 text-center text-xs font-semibold uppercase tracking-wider">
                      Süre
                    </th>
                    <th className="px-6 py-4 text-center text-xs font-semibold uppercase tracking-wider">
                      Ücret
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-100">
                  {filteredLessons.map((lesson, index) => (
                    <tr 
                      key={lesson.id} 
                      className={`
                        ${index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}
                        hover:bg-blue-50 transition-colors duration-150 cursor-pointer
                      `}
                    >
                      <td className="px-6 py-4">
                        <div className="flex items-center">
                          <div className="h-10 w-10 flex-shrink-0 rounded-full bg-gradient-to-r from-blue-400 to-blue-600 flex items-center justify-center text-white font-bold text-sm">
                            {(lesson.ogrenci_adi || 'Ö')[0].toUpperCase()}
                          </div>
                          <div className="ml-3">
                            <p className="text-sm font-semibold text-gray-900">
                              {lesson.ogrenci_adi || '-'}
                            </p>
                          </div>
                        </div>
                      </td>
                      <td className="px-6 py-4">
                        <div className="text-sm text-gray-900 font-medium">
                          {lesson.ders_adi || '-'}
                        </div>
                      </td>
                      <td className="px-6 py-4 max-w-xs">
                        <div className="text-sm text-gray-700 truncate" title={lesson.ders_konusu}>
                          {lesson.ders_konusu}
                        </div>
                      </td>
                      <td className="px-6 py-4 text-center">
                        <div className="text-sm">
                          <div className="text-gray-900 font-medium">
                            {new Date(lesson.baslangic_tarihi).toLocaleDateString('tr-TR', {
                              day: '2-digit',
                              month: '2-digit',
                              year: 'numeric'
                            })}
                          </div>
                          <div className="text-gray-500 text-xs">
                            {new Date(lesson.baslangic_tarihi).toLocaleTimeString('tr-TR', {
                              hour: '2-digit',
                              minute: '2-digit'
                            })}
                          </div>
                        </div>
                      </td>
                      <td className="px-6 py-4 text-center">
                        <span className="inline-flex items-center px-3 py-1 text-xs font-bold rounded-full bg-gradient-to-r from-purple-400 to-purple-600 text-white shadow-sm">
                          <svg className="w-3 h-3 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                          </svg>
                          {lesson.ders_sure} dk
                        </span>
                      </td>
                      <td className="px-6 py-4 text-center">
                        <span className="inline-flex items-center px-3 py-1 text-sm font-bold rounded-full bg-gradient-to-r from-green-400 to-green-600 text-white shadow-sm">
                          ₺{parseFloat(lesson.ders_ucret || 0).toFixed(2)}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            
            {/* Tablo Alt Bilgi */}
            <div className="bg-gray-50 px-6 py-3 border-t border-gray-200">
              <div className="flex items-center justify-between">
                <div className="text-sm text-gray-600">
                  Toplam <span className="font-semibold text-gray-900">{filteredLessons.length}</span> ders gösteriliyor
                </div>
                <div className="flex items-center gap-4">
                  <div className="text-sm text-gray-600">
                    Brüt: <span className="font-bold text-gray-700">₺{filteredLessons.reduce((sum, lesson) => sum + parseFloat(lesson.ders_ucret || 0), 0).toFixed(2)}</span>
                  </div>
                  {avansBalance > 0 && (
                    <div className="text-sm text-gray-600">
                      Avans: <span className="font-bold text-orange-600">-₺{avansBalance.toFixed(2)}</span>
                    </div>
                  )}
                  <div className="text-sm text-gray-600">
                    Net: <span className="font-bold text-green-600">₺{Math.max(0, filteredLessons.reduce((sum, lesson) => sum + parseFloat(lesson.ders_ucret || 0), 0) - avansBalance).toFixed(2)}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      {/* Yeni Ders Ekleme Modal */}
      {showAddModal && (
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-lg max-w-md w-full p-6">
            <h2 className="text-xl font-bold mb-4">Yeni Ders Ekle</h2>
            <form onSubmit={handleAddLesson}>
              <div className="space-y-4">
                {/* Kurs Satış Seçimi (Yeni) */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Kurs Satış Seçin
                  </label>
                  <select
                    value={formData.kurs_satis_id}
                    onChange={handleKursSatisChange}
                    className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:border-blue-500"
                    required
                  >
                    <option value="">-- Kurs Satış Seçin --</option>
                    {kursSatisList.map((ks) => (
                      <option key={ks.id} value={ks.id}>
                        {ks.display_text}
                      </option>
                    ))}
                  </select>
                  <p className="text-xs text-gray-500 mt-1">
                    Kurs satışı seçimi zorunludur. Seçince öğrenci ve ders otomatik doldurulur.
                  </p>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Öğrenci
                  </label>
                  <select
                    value={formData.ogrenci_id}
                    onChange={(e) => setFormData({...formData, ogrenci_id: e.target.value})}
                    className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:border-blue-500"
                    required
                    disabled={formData.kurs_satis_id !== ''} // Kurs satış seçiliyse disable
                  >
                    <option value="">Öğrenci Seçin</option>
                    {students.map((student) => (
                      <option key={student.id} value={student.id}>
                        {student.name} - {student.sinif}. Sınıf
                      </option>
                    ))}
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Ders
                  </label>
                  <select
                    value={formData.ders_id}
                    onChange={(e) => setFormData({...formData, ders_id: e.target.value})}
                    className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:border-blue-500"
                    required
                  >
                    <option value="">Ders Seçin</option>
                    {courses.map((course) => (
                      <option key={course.id} value={course.id}>
                        {course.ders_adi}
                      </option>
                    ))}
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Ders Konusu
                  </label>
                  <input
                    type="text"
                    value={formData.ders_konusu}
                    onChange={(e) => setFormData({...formData, ders_konusu: e.target.value})}
                    className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:border-blue-500"
                    required
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Başlangıç Tarihi
                  </label>
                  <input
                    type="date"
                    value={formData.baslangic_tarihi}
                    onChange={(e) => setFormData({...formData, baslangic_tarihi: e.target.value})}
                    min={(() => {
                      const firstDay = new Date();
                      firstDay.setDate(1);
                      return firstDay.toISOString().split('T')[0];
                    })()} // Bu ayın ilk gününden başlat
                    max={new Date().toISOString().split('T')[0]} // Bugüne kadar izin ver
                    className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:border-blue-500"
                    required
                  />
                  <p className="text-xs text-gray-500 mt-1">
                    * Sadece {new Date().toLocaleDateString('tr-TR', { month: 'long', year: 'numeric' })} ayı içindeki tarihleri (bugüne kadar) seçebilirsiniz
                  </p>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Ders Süresi
                  </label>
                  <select
                    value={formData.ders_sure}
                    onChange={(e) => setFormData({...formData, ders_sure: e.target.value})}
                    className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:border-blue-500"
                    required
                  >
                    <option value="40">40 Dakika</option>
                    <option value="60">60 Dakika</option>
                    <option value="80">80 Dakika</option>
                    <option value="120">120 Dakika</option>
                  </select>
                </div>
              </div>

              <div className="mt-6 flex justify-end space-x-3">
                <button
                  type="button"
                  onClick={() => {
                    setShowAddModal(false);
                    resetForm();
                  }}
                  className="px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50"
                >
                  İptal
                </button>
                <button
                  type="submit"
                  disabled={!formData.kurs_satis_id}
                  className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  Ekle
                </button>
              </div>
            </form>
          </div>
        </div>
      )}


    </div>
  );
}
